// export const lands = [
//   {
//     id: 1,
//     title: "أرض في الرياض",
//     location: "الرياض",
//     price: 250000,
//     shape: [
//       [
//         [21.484, 39.192],
//         [21.484, 39.194],
//         [21.486, 39.194],
//         [21.486, 39.192],
//         [21.484, 39.192],
//       ],
//     ],
//   },
//   {
//     id: 2,
//     title: "أرض في جدة",
//     location: "جدة",
//     price: 150000,
//     image: "../images/saudi-arabia.jpg",
//   },
//   {
//     id: 3,
//     title: "أرض في الدمام",
//     location: "الدمام",
//     price: 90000,
//     image: "/images/land3.jpg",
//   },
//   {
//     id: 4,
//     title: "أرض في الرياض (رخيصة)",
//     location: "الرياض",
//     price: 80000,
//     image: "/images/land1.jpg",
//   },
// ];
export const shape = [
  [
    [
      [39.674140859186615, 24.42204576546118],
      [39.67417884848166, 24.422021267523245],
      [39.67409906779291, 24.421991434626264],
      [39.674140859186615, 24.42204576546118],
    ],
  ],
  [
    [
      [39.67428075571375, 24.42222763378544],
      [39.67444591074966, 24.42212113056083],
      [39.67417884848166, 24.422021267523245],
      [39.674140859186615, 24.42204576546118],
      [39.67428075571375, 24.42222763378544],
    ],
  ],
  [
    [
      [39.674640253255355, 24.42230288594882],
      [39.67452246169541, 24.422149754818467],
      [39.67444591074966, 24.42212113056083],
      [39.67428075571375, 24.42222763378544],
      [39.67441592780074, 24.422403360916807],
      [39.6744709036619, 24.422412094911305],
      [39.674640253255355, 24.42230288594882],
    ],
  ],
  [
    [
      [39.674640253255355, 24.42230288594882],
      [39.67474732622237, 24.42223383791297],
      [39.67452246169541, 24.422149754818467],
      [39.674640253255355, 24.42230288594882],
    ],
  ],
  [
    [
      [39.674722176802625, 24.422702959140835],
      [39.67478656802322, 24.422429460397456],
      [39.674584497958215, 24.422559769061195],
      [39.67457495999196, 24.42261010548219],
      [39.674671515437716, 24.42273562929816],
      [39.674722176802625, 24.422702959140835],
    ],
  ],
  [
    [
      [39.67471173798184, 24.422747297335146],
      [39.674722176802625, 24.422702959140835],
      [39.674671515437716, 24.42273562929816],
      [39.674708188126246, 24.422783304985245],
      [39.67471173798184, 24.422747297335146],
    ],
  ],
  [
    [
      [39.674662268399494, 24.42324912478334],
      [39.67467713795333, 24.42309828697],
      [39.674456631264384, 24.42324048347225],
      [39.674575905731686, 24.42339554252578],
      [39.674613439221105, 24.423371339125683],
      [39.674662268399494, 24.42324912478334],
    ],
  ],
  [
    [
      [39.674594244130944, 24.423419381272694],
      [39.674613439221105, 24.423371339125683],
      [39.674575905731686, 24.42339554252578],
      [39.674594244130944, 24.423419381272694],
    ],
  ],
  [
    [
      [39.6743339755135, 24.423551553904357],
      [39.674575905731686, 24.42339554252578],
      [39.674456631264384, 24.42324048347225],
      [39.67421470119012, 24.423396495563203],
      [39.6743339755135, 24.423551553904357],
    ],
  ],
  [
    [
      [39.674494532437684, 24.423668945254448],
      [39.674594244130944, 24.423419381272694],
      [39.674575905731686, 24.42339554252578],
      [39.6743339755135, 24.423551553904357],
      [39.67444757071255, 24.423699229019384],
      [39.674494532437684, 24.423668945254448],
    ],
  ],
  [
    [
      [39.67447051485609, 24.42372905672821],
      [39.674494532437684, 24.423668945254448],
      [39.67444757071255, 24.423699229019384],
      [39.67447051485609, 24.42372905672821],
    ],
  ],
  [
    [
      [39.67441119312405, 24.423181413975946],
      [39.674278254989176, 24.423008592246156],
      [39.674036325123, 24.423164604051845],
      [39.67416926309801, 24.423337425091106],
      [39.67441119312405, 24.423181413975946],
    ],
  ],
  [
    [
      [39.67441119312405, 24.423181413975946],
      [39.67465312353158, 24.423025401576222],
      [39.67452018524162, 24.422852580059043],
      [39.674278254989176, 24.423008592246156],
      [39.67441119312405, 24.423181413975946],
    ],
  ],
  [
    [
      [39.674278254989176, 24.423008592246156],
      [39.67452018524162, 24.422852580059043],
      [39.67440091038739, 24.422697521845485],
      [39.67415898126044, 24.42285353383745],
      [39.674278254989176, 24.423008592246156],
    ],
  ],
  [
    [
      [39.674278254989176, 24.423008592246156],
      [39.67415898126044, 24.42285353383745],
      [39.67391705054225, 24.423009544553672],
      [39.674036325123, 24.423164604051845],
      [39.674278254989176, 24.423008592246156],
    ],
  ],
  [
    [
      [39.67415898126044, 24.42285353383745],
      [39.67403970683459, 24.422698474426554],
      [39.673797777246705, 24.42285448585074],
      [39.67391705054225, 24.423009544553672],
      [39.67415898126044, 24.42285353383745],
    ],
  ],
  [
    [
      [39.67415898126044, 24.42285353383745],
      [39.67440091038739, 24.422697521845485],
      [39.674281636813575, 24.422542463524042],
      [39.67403970683459, 24.422698474426554],
      [39.67415898126044, 24.42285353383745],
    ],
  ],
  [
    [
      [39.67403970683459, 24.422698474426554],
      [39.674281636813575, 24.422542463524042],
      [39.67416236254262, 24.422387404200386],
      [39.67392043369394, 24.422543415810868],
      [39.67403970683459, 24.422698474426554],
    ],
  ],
  [
    [
      [39.673797777246705, 24.42285448585074],
      [39.67403970683459, 24.422698474426554],
      [39.67392043369394, 24.422543415810868],
      [39.673678503258834, 24.422699427048713],
      [39.673797777246705, 24.42285448585074],
    ],
  ],
  [
    [
      [39.673678503258834, 24.422699427048713],
      [39.67392043369394, 24.422543415810868],
      [39.67380116084731, 24.42238835709168],
      [39.67355923054656, 24.42254436723567],
      [39.673678503258834, 24.422699427048713],
    ],
  ],
  [
    [
      [39.67416236254262, 24.422387404200386],
      [39.67404308955686, 24.422232345671947],
      [39.67380116084731, 24.42238835709168],
      [39.67392043369394, 24.422543415810868],
      [39.67416236254262, 24.422387404200386],
    ],
  ],
  [
    [
      [39.67380116084731, 24.42238835709168],
      [39.67404308955686, 24.422232345671947],
      [39.67392381686512, 24.422077287040015],
      [39.67368188730357, 24.4222332973703],
      [39.67380116084731, 24.42238835709168],
    ],
  ],
  [
    [
      [39.67355923054656, 24.42254436723567],
      [39.67380116084731, 24.42238835709168],
      [39.67368188730357, 24.4222332973703],
      [39.6734399581331, 24.42238930822226],
      [39.67355923054656, 24.42254436723567],
    ],
  ],
  [
    [
      [39.6734399581331, 24.42238930822226],
      [39.67368188730357, 24.4222332973703],
      [39.673516345413944, 24.422018085882062],
      [39.67328592861451, 24.42212691683311],
      [39.67327358312093, 24.422173013702093],
      [39.6734399581331, 24.42238930822226],
    ],
  ],
  [
    [
      [39.67368188730357, 24.4222332973703],
      [39.67392381686512, 24.422077287040015],
      [39.67380454347626, 24.421922227405883],
      [39.67374676082505, 24.4219092545916],
      [39.673516345413944, 24.422018085882062],
      [39.67368188730357, 24.4222332973703],
    ],
  ],
  [
    [
      [39.673717409077916, 24.423063690536324],
      [39.67359813596489, 24.422908630769825],
      [39.67354315994434, 24.422899897365316],
      [39.673333486135014, 24.42303510613648],
      [39.6734754783907, 24.423219700558377],
      [39.673717409077916, 24.423063690536324],
    ],
  ],
  [
    [
      [39.673233546121836, 24.423375711110882],
      [39.6734754783907, 24.423219700558377],
      [39.673333486135014, 24.42303510613648],
      [39.673123811874966, 24.42317031462442],
      [39.673114273291915, 24.423220651866007],
      [39.673233546121836, 24.423375711110882],
    ],
  ],
  [
    [
      [39.67359475165861, 24.42337476041213],
      [39.6734754783907, 24.423219700558377],
      [39.673233546121836, 24.423375711110882],
      [39.673352820232154, 24.423530770247858],
      [39.67359475165861, 24.42337476041213],
    ],
  ],
  [
    [
      [39.67359475165861, 24.42337476041213],
      [39.67383668346655, 24.42321874929181],
      [39.673717409077916, 24.423063690536324],
      [39.6734754783907, 24.423219700558377],
      [39.67359475165861, 24.42337476041213],
    ],
  ],
  [
    [
      [39.67371402620214, 24.423529819254885],
      [39.67395595716285, 24.42337380794821],
      [39.67383668346655, 24.42321874929181],
      [39.67359475165861, 24.42337476041213],
      [39.67371402620214, 24.423529819254885],
    ],
  ],
  [
    [
      [39.67347209365495, 24.423685830188873],
      [39.67371402620214, 24.423529819254885],
      [39.67359475165861, 24.42337476041213],
      [39.673352820232154, 24.423530770247858],
      [39.67347209365495, 24.423685830188873],
    ],
  ],
  [
    [
      [39.673591367367, 24.42384088912328],
      [39.67383330005334, 24.42368487799852],
      [39.67371402620214, 24.423529819254885],
      [39.67347209365495, 24.423685830188873],
      [39.673591367367, 24.42384088912328],
    ],
  ],
  [
    [
      [39.67383330005334, 24.42368487799852],
      [39.674075231158014, 24.42352886740423],
      [39.67395595716285, 24.42337380794821],
      [39.67371402620214, 24.423529819254885],
      [39.67383330005334, 24.42368487799852],
    ],
  ],
  [
    [
      [39.6739525742034, 24.423839937541796],
      [39.674194506428776, 24.423683925849236],
      [39.674075231158014, 24.42352886740423],
      [39.67383330005334, 24.42368487799852],
      [39.6739525742034, 24.423839937541796],
    ],
  ],
  [
    [
      [39.67371064235947, 24.423995947949777],
      [39.6739525742034, 24.423839937541796],
      [39.67383330005334, 24.42368487799852],
      [39.673591367367, 24.42384088912328],
      [39.67371064235947, 24.423995947949777],
    ],
  ],
  [
    [
      [39.674071849629065, 24.423994996074065],
      [39.6739525742034, 24.423839937541796],
      [39.67371064235947, 24.423995947949777],
      [39.673829916664424, 24.42415100758031],
      [39.674071849629065, 24.423994996074065],
    ],
  ],
  [
    [
      [39.674071849629065, 24.423994996074065],
      [39.67431378100723, 24.423838984195125],
      [39.674194506428776, 24.423683925849236],
      [39.6739525742034, 24.423839937541796],
      [39.674071849629065, 24.423994996074065],
    ],
  ],
  [
    [
      [39.67419112436242, 24.4241500545072],
      [39.674433056870896, 24.42399404333625],
      [39.67431378100723, 24.423838984195125],
      [39.674071849629065, 24.423994996074065],
      [39.67419112436242, 24.4241500545072],
    ],
  ],
  [
    [
      [39.67419112436242, 24.4241500545072],
      [39.674071849629065, 24.423994996074065],
      [39.673829916664424, 24.42415100758031],
      [39.673949192245, 24.424306066199826],
      [39.67419112436242, 24.4241500545072],
    ],
  ],
  [
    [
      [39.67435583889123, 24.424364183245714],
      [39.674557882534934, 24.424233893947935],
      [39.67446973168955, 24.42405876396528],
      [39.67423656276542, 24.4242091249599],
      [39.67435583889123, 24.424364183245714],
    ],
  ],
  [
    [
      [39.67411390559528, 24.424520195206167],
      [39.67435583889123, 24.424364183245714],
      [39.67423656276542, 24.4242091249599],
      [39.673994630590194, 24.424365135822068],
      [39.67411390559528, 24.424520195206167],
    ],
  ],
  [
    [
      [39.674632092623035, 24.424381329005588],
      [39.674557882534934, 24.424233893947935],
      [39.67435583889123, 24.424364183245714],
      [39.67444034031934, 24.424474035453013],
      [39.674632092623035, 24.424381329005588],
    ],
  ],
  [
    [
      [39.67417651354274, 24.424601586084655],
      [39.67444034031934, 24.424474035453013],
      [39.67435583889123, 24.424364183245714],
      [39.67411390559528, 24.424520195206167],
      [39.67417651354274, 24.424601586084655],
    ],
  ],
  [
    [
      [39.67380846010968, 24.424907325106595],
      [39.6740176140621, 24.42470869879354],
      [39.673956072922245, 24.42462869573592],
      [39.67371381481969, 24.424784285846815],
      [39.67380846010968, 24.424907325106595],
    ],
  ],
  [
    [
      [39.67368872636861, 24.425021031192834],
      [39.67380846010968, 24.424907325106595],
      [39.67371381481969, 24.424784285846815],
      [39.67347155710412, 24.424939875575195],
      [39.67358515260104, 24.425087551305538],
      [39.67368872636861, 24.425021031192834],
    ],
  ],
  [
    [
      [39.67359930648442, 24.42510595023211],
      [39.67368872636861, 24.425021031192834],
      [39.67358515260104, 24.425087551305538],
      [39.67359930648442, 24.42510595023211],
    ],
  ],
  [
    [
      [39.67347155710412, 24.424939875575195],
      [39.67371381481969, 24.424784285846815],
      [39.67359708773034, 24.424632538352],
      [39.67338741116447, 24.424767747228028],
      [39.673377872577944, 24.4248180835729],
      [39.67347155710412, 24.424939875575195],
    ],
  ],
  [
    [
      [39.67371381481969, 24.424784285846815],
      [39.673956072922245, 24.42462869573592],
      [39.673861740576804, 24.42450606248422],
      [39.67380676384546, 24.424497329192736],
      [39.67359708773034, 24.424632538352],
      [39.67371381481969, 24.424784285846815],
    ],
  ],
  [
    [
      [39.67343241317032, 24.425202673912768],
      [39.67321658238275, 24.424922090268726],
      [39.67316160452235, 24.424913356750665],
      [39.672529204738986, 24.42532115241455],
      [39.67251966479298, 24.425371489617437],
      [39.672736948773974, 24.42565113665793],
      [39.67343241317032, 24.425202673912768],
    ],
  ],
  [
    [
      [39.67312804394037, 24.42564665828635],
      [39.67318441590124, 24.425534382402024],
      [39.673315580389406, 24.425395843765795],
      [39.67328907241069, 24.42536138420173],
      [39.67303412536323, 24.425525784714107],
      [39.67312804394037, 24.42564665828635],
    ],
  ],
  [
    [
      [39.672886016741955, 24.42584298929777],
      [39.673098149276534, 24.42570619871309],
      [39.673099081446765, 24.425704343135827],
      [39.67298496943406, 24.42555748126949],
      [39.67277125629149, 24.425695292042896],
      [39.672886016741955, 24.42584298929777],
    ],
  ],
  [
    [
      [39.67296795589178, 24.426236888493946],
      [39.67297119045669, 24.42614673471287],
      [39.67292278891424, 24.426177694547718],
      [39.67296795589178, 24.426236888493946],
    ],
  ],
  [
    [
      [39.67293053988532, 24.426503243679317],
      [39.67295905592884, 24.426485004453824],
      [39.67296795589178, 24.426236888493946],
      [39.67292278891424, 24.426177694547718],
      [39.67276106653981, 24.4262811391401],
      [39.67293053988532, 24.426503243679317],
    ],
  ],
  [
    [
      [39.67293053988532, 24.426503243679317],
      [39.67276106653981, 24.4262811391401],
      [39.672599343899314, 24.42638458356396],
      [39.67276881710922, 24.42660668828442],
      [39.67293053988532, 24.426503243679317],
    ],
  ],
  [
    [
      [39.67297643921954, 24.42680439288108],
      [39.67295512699619, 24.426594510125426],
      [39.67295714983914, 24.42653811738504],
      [39.67293053988532, 24.426503243679317],
      [39.67276881710922, 24.42660668828442],
      [39.67293829190417, 24.426828792791362],
      [39.67297643921954, 24.42680439288108],
    ],
  ],
  [
    [
      [39.67295714983914, 24.42653811738504],
      [39.67295905592884, 24.426485004453824],
      [39.67293053988532, 24.426503243679317],
      [39.67295714983914, 24.42653811738504],
    ],
  ],
  [
    [
      [39.67276881710922, 24.42660668828442],
      [39.672599343899314, 24.42638458356396],
      [39.67245737985339, 24.42647538911937],
      [39.672447907725854, 24.42652551377357],
      [39.67259658103749, 24.42671685814793],
      [39.67276881710922, 24.42660668828442],
    ],
  ],
  [
    [
      [39.67293829190417, 24.426828792791362],
      [39.67276881710922, 24.42660668828442],
      [39.67259658103749, 24.42671685814793],
      [39.67274525479657, 24.42690820145857],
      [39.67280047129709, 24.42691694850041],
      [39.67293829190417, 24.426828792791362],
    ],
  ],
  [
    [
      [39.67235571581496, 24.42720143107956],
      [39.6725740523636, 24.427061775079242],
      [39.67258352545726, 24.42701164951338],
      [39.67242170596708, 24.42680338729061],
      [39.67214038823257, 24.42698662103115],
      [39.67230049823017, 24.427192683882144],
      [39.67235571581496, 24.42720143107956],
    ],
  ],
  [
    [
      [39.67214038823257, 24.42698662103115],
      [39.67242170596708, 24.42680338729061],
      [39.672250167698856, 24.426582615354064],
      [39.671968850184925, 24.42676584787264],
      [39.67214038823257, 24.42698662103115],
    ],
  ],
  [
    [
      [39.671968850184925, 24.42676584787264],
      [39.672250167698856, 24.426582615354064],
      [39.672078629041486, 24.426361842304978],
      [39.67179731175771, 24.426545075407816],
      [39.671968850184925, 24.42676584787264],
    ],
  ],
  [
    [
      [39.67179731175771, 24.426545075407816],
      [39.672078629041486, 24.426361842304978],
      [39.67190709099094, 24.426141069945214],
      [39.67162577393254, 24.42632430272921],
      [39.67179731175771, 24.426545075407816],
    ],
  ],
  [
    [
      [39.67162577393254, 24.42632430272921],
      [39.67190709099094, 24.426141069945214],
      [39.67173555452879, 24.42592029736728],
      [39.671454237690995, 24.426103528929332],
      [39.67162577393254, 24.42632430272921],
    ],
  ],
  [
    [
      [39.67173555452879, 24.42592029736728],
      [39.67156401767749, 24.42569952367685],
      [39.67155200032285, 24.425707351213045],
      [39.671442625839134, 24.425973475407645],
      [39.67130592682382, 24.425867628200116],
      [39.67128270106984, 24.42588275582317],
      [39.671454237690995, 24.426103528929332],
      [39.67173555452879, 24.42592029736728],
    ],
  ],
  [
    [
      [39.6719145796279, 24.4253717173349],
      [39.671794504285764, 24.425217175446022],
      [39.67173845305065, 24.42525368432313],
      [39.67164202091665, 24.425488319326668],
      [39.67167345277722, 24.425528773128438],
      [39.6719145796279, 24.4253717173349],
    ],
  ],
  [
    [
      [39.67173845305065, 24.42525368432313],
      [39.671794504285764, 24.425217175446022],
      [39.67176213690597, 24.425175518325418],
      [39.67174835324832, 24.425229596152615],
      [39.67173845305065, 24.42525368432313],
    ],
  ],
  [
    [
      [39.671794504285764, 24.425217175446022],
      [39.672035630399236, 24.425060119469247],
      [39.67190093578599, 24.42488676249221],
      [39.67184580663882, 24.42487812760783],
      [39.67183639500337, 24.424884196026728],
      [39.67176213690597, 24.425175518325418],
      [39.671794504285764, 24.425217175446022],
    ],
  ],
  [
    [
      [39.6719145796279, 24.4253717173349],
      [39.67215570587181, 24.4252146602637],
      [39.672035630399236, 24.425060119469247],
      [39.671794504285764, 24.425217175446022],
      [39.6719145796279, 24.4253717173349],
    ],
  ],
  [
    [
      [39.672034655260234, 24.42552625821591],
      [39.67227578163935, 24.42536920095341],
      [39.67215570587181, 24.4252146602637],
      [39.6719145796279, 24.4253717173349],
      [39.672034655260234, 24.42552625821591],
    ],
  ],
  [
    [
      [39.67215473118755, 24.425680798992154],
      [39.672395857701865, 24.425523741538363],
      [39.672363350000715, 24.425481902742554],
      [39.67227578163935, 24.42536920095341],
      [39.672034655260234, 24.42552625821591],
      [39.672094692693825, 24.42560352861931],
      [39.67215473118755, 24.425680798992154],
    ],
  ],
  [
    [
      [39.67227480740984, 24.42583533966366],
      [39.672515934059376, 24.42567828201855],
      [39.672395857701865, 24.425523741538363],
      [39.67215473118755, 24.425680798992154],
      [39.67227480740984, 24.42583533966366],
    ],
  ],
  [
    [
      [39.67263601071186, 24.425832822393993],
      [39.672515934059376, 24.42567828201855],
      [39.67227480740984, 24.42583533966366],
      [39.67239488392712, 24.425989880230386],
      [39.67263601071186, 24.425832822393993],
    ],
  ],
  [
    [
      [39.6721537555492, 24.42614693679352],
      [39.67239488392712, 24.425989880230386],
      [39.67227480740984, 24.42583533966366],
      [39.67203367916713, 24.42599239603547],
      [39.6721537555492, 24.42614693679352],
    ],
  ],
  [
    [
      [39.67203367916713, 24.42599239603547],
      [39.67227480740984, 24.42583533966366],
      [39.67215473118755, 24.425680798992154],
      [39.67191360406643, 24.425837855168293],
      [39.67203367916713, 24.42599239603547],
    ],
  ],
  [
    [
      [39.67215473118755, 24.425680798992154],
      [39.672094692693825, 24.42560352861931],
      [39.672034655260234, 24.42552625821591],
      [39.671793528274335, 24.42568331420074],
      [39.67185356564032, 24.4257605846998],
      [39.67191360406643, 24.425837855168293],
      [39.67215473118755, 24.425680798992154],
    ],
  ],
  [
    [
      [39.672034655260234, 24.42552625821591],
      [39.6719145796279, 24.4253717173349],
      [39.67167345277722, 24.425528773128438],
      [39.671793528274335, 24.42568331420074],
      [39.672034655260234, 24.42552625821591],
    ],
  ],
  [
    [
      [39.67277298571385, 24.42600911003975],
      [39.67263601071186, 24.425832822393993],
      [39.67239488392712, 24.425989880230386],
      [39.672553264890254, 24.42619371888627],
      [39.67276351276, 24.42605923562082],
      [39.67277298571385, 24.42600911003975],
    ],
  ],
  [
    [
      [39.672553264890254, 24.42619371888627],
      [39.67239488392712, 24.425989880230386],
      [39.6721537555492, 24.42614693679352],
      [39.67228780035487, 24.42631945465119],
      [39.67234301657082, 24.426328201866877],
      [39.672553264890254, 24.42619371888627],
    ],
  ],
  [
    [
      [39.67256038627591, 24.424748731011416],
      [39.672389995853784, 24.42452721616608],
      [39.67222870518508, 24.424631221822466],
      [39.672399096461014, 24.42485273684507],
      [39.67256038627591, 24.424748731011416],
    ],
  ],
  [
    [
      [39.67272167681046, 24.424644725005756],
      [39.67255128526941, 24.424423210346486],
      [39.672389995853784, 24.42452721616608],
      [39.67256038627591, 24.424748731011416],
      [39.67272167681046, 24.424644725005756],
    ],
  ],
  [
    [
      [39.67288296707829, 24.42454071883251],
      [39.672712575404674, 24.424319204354916],
      [39.67255128526941, 24.424423210346486],
      [39.67272167681046, 24.424644725005756],
      [39.67288296707829, 24.42454071883251],
    ],
  ],
  [
    [
      [39.67304425609303, 24.424436712496046],
      [39.67287386527323, 24.424215198195736],
      [39.672712575404674, 24.424319204354916],
      [39.67288296707829, 24.42454071883251],
      [39.67304425609303, 24.424436712496046],
    ],
  ],
  [
    [
      [39.673205545822626, 24.42433270508448],
      [39.67303515388871, 24.424111191873326],
      [39.67287386527323, 24.424215198195736],
      [39.67304425609303, 24.424436712496046],
      [39.673205545822626, 24.42433270508448],
    ],
  ],
  [
    [
      [39.6733668352903, 24.42422869840842],
      [39.67319644322384, 24.424007185378947],
      [39.67303515388871, 24.424111191873326],
      [39.673205545822626, 24.42433270508448],
      [39.6733668352903, 24.42422869840842],
    ],
  ],
  [
    [
      [39.6735372269753, 24.424450212134204],
      [39.6733668352903, 24.42422869840842],
      [39.673205545822626, 24.42433270508448],
      [39.67337593836145, 24.42455421898753],
      [39.6735372269753, 24.424450212134204],
    ],
  ],
  [
    [
      [39.67337593836145, 24.42455421898753],
      [39.673205545822626, 24.42433270508448],
      [39.67304425609303, 24.424436712496046],
      [39.67321464849452, 24.42465822567766],
      [39.67337593836145, 24.42455421898753],
    ],
  ],
  [
    [
      [39.67321464849452, 24.42465822567766],
      [39.67304425609303, 24.424436712496046],
      [39.67288296707829, 24.42454071883251],
      [39.67305335836086, 24.424762232200177],
      [39.67321464849452, 24.42465822567766],
    ],
  ],
  [
    [
      [39.67305335836086, 24.424762232200177],
      [39.67288296707829, 24.42454071883251],
      [39.67272167681046, 24.424644725005756],
      [39.67289206894685, 24.424866238550727],
      [39.67305335836086, 24.424762232200177],
    ],
  ],
  [
    [
      [39.67289206894685, 24.424866238550727],
      [39.67272167681046, 24.424644725005756],
      [39.67256038627591, 24.424748731011416],
      [39.67273077827975, 24.424970244738045],
      [39.67289206894685, 24.424866238550727],
    ],
  ],
  [
    [
      [39.67273077827975, 24.424970244738045],
      [39.67256038627591, 24.424748731011416],
      [39.672399096461014, 24.42485273684507],
      [39.67256948734592, 24.425074250757756],
      [39.67273077827975, 24.424970244738045],
    ],
  ],
  [
    [
      [39.67370270707167, 24.424299317247087],
      [39.67355503385082, 24.424107339038365],
      [39.6733668352903, 24.42422869840842],
      [39.6735372269753, 24.424450212134204],
      [39.67369316864118, 24.424349653611458],
      [39.67370270707167, 24.424299317247087],
    ],
  ],
  [
    [
      [39.6733668352903, 24.42422869840842],
      [39.67355503385082, 24.424107339038365],
      [39.673407360094345, 24.423915360675366],
      [39.67335238364708, 24.423906627211895],
      [39.67319644322384, 24.424007185378947],
      [39.6733668352903, 24.42422869840842],
    ],
  ],
  [
    [
      [39.67256948734592, 24.425074250757756],
      [39.672399096461014, 24.42485273684507],
      [39.672210895670034, 24.42497409481355],
      [39.672359562772314, 24.425165433202586],
      [39.672414692079776, 24.42517406879912],
      [39.67256948734592, 24.425074250757756],
    ],
  ],
  [
    [
      [39.672210895670034, 24.42497409481355],
      [39.672399096461014, 24.42485273684507],
      [39.67222870518508, 24.424631221822466],
      [39.672071615761965, 24.424732519109163],
      [39.67206222901993, 24.42478275626395],
      [39.672210895670034, 24.42497409481355],
    ],
  ],
  [
    [
      [39.67243234387556, 24.424278983150035],
      [39.67226195333909, 24.424057468132734],
      [39.672100664135556, 24.424161473643995],
      [39.67227105355311, 24.424382988847338],
      [39.67243234387556, 24.424278983150035],
    ],
  ],
  [
    [
      [39.672593632944945, 24.424174977289493],
      [39.67242324326228, 24.423953462449496],
      [39.67226195333909, 24.424057468132734],
      [39.67243234387556, 24.424278983150035],
      [39.672593632944945, 24.424174977289493],
    ],
  ],
  [
    [
      [39.672916212256304, 24.42396696505687],
      [39.67274582132216, 24.423745450584576],
      [39.672584531932394, 24.423849456603033],
      [39.67275492273398, 24.42407097125698],
      [39.672916212256304, 24.42396696505687],
    ],
  ],
  [
    [
      [39.67275492273398, 24.42407097125698],
      [39.672584531932394, 24.423849456603033],
      [39.67242324326228, 24.423953462449496],
      [39.672593632944945, 24.424174977289493],
      [39.67275492273398, 24.42407097125698],
    ],
  ],
  [
    [
      [39.673248328082835, 24.423708614912552],
      [39.67310065624889, 24.4235166362157],
      [39.67290711044524, 24.423641444398534],
      [39.67307750052076, 24.423862957790423],
      [39.673238789509654, 24.423758951255124],
      [39.673248328082835, 24.423708614912552],
    ],
  ],
  [
    [
      [39.67307750052076, 24.423862957790423],
      [39.67290711044524, 24.423641444398534],
      [39.67274582132216, 24.423745450584576],
      [39.672916212256304, 24.42396696505687],
      [39.67307750052076, 24.423862957790423],
    ],
  ],
  [
    [
      [39.67290711044524, 24.423641444398534],
      [39.67310065624889, 24.4235166362157],
      [39.67295298487047, 24.423324658263308],
      [39.67289800870246, 24.423315923724747],
      [39.672736719978644, 24.423419929896713],
      [39.67290711044524, 24.423641444398534],
    ],
  ],
  [
    [
      [39.67290711044524, 24.423641444398534],
      [39.672736719978644, 24.423419929896713],
      [39.672575431979276, 24.423523936799832],
      [39.67274582132216, 24.423745450584576],
      [39.67290711044524, 24.423641444398534],
    ],
  ],
  [
    [
      [39.67274582132216, 24.423745450584576],
      [39.672575431979276, 24.423523936799832],
      [39.67241414272206, 24.42362794263661],
      [39.672584531932394, 24.423849456603033],
      [39.67274582132216, 24.423745450584576],
    ],
  ],
  [
    [
      [39.67242324326228, 24.423953462449496],
      [39.672584531932394, 24.423849456603033],
      [39.67241414272206, 24.42362794263661],
      [39.67236331719337, 24.423660716624017],
      [39.67233426997, 24.423805699879043],
      [39.67232280054341, 24.42382288244657],
      [39.67242324326228, 24.423953462449496],
    ],
  ],
  [
    [
      [39.67226195333909, 24.424057468132734],
      [39.67242324326228, 24.423953462449496],
      [39.67232280054341, 24.42382288244657],
      [39.67223137774842, 24.423959843849797],
      [39.672209006069586, 24.42398863499492],
      [39.67226195333909, 24.424057468132734],
    ],
  ],
  [
    [
      [39.672100664135556, 24.424161473643995],
      [39.67226195333909, 24.424057468132734],
      [39.672209006069586, 24.42398863499492],
      [39.67208774814493, 24.42414468388142],
      [39.672100664135556, 24.424161473643995],
    ],
  ],
  [
    [
      [39.672816672539774, 24.42314744652698],
      [39.67253858429635, 24.422785917566454],
      [39.67244384903831, 24.4232587661207],
      [39.672487506442415, 24.42331552307232],
      [39.67254248258107, 24.42332425685752],
      [39.672816672539774, 24.42314744652698],
    ],
  ],
  [
    [
      [39.67298602556155, 24.42303824027277],
      [39.67342956553396, 24.42275222152191],
      [39.67343910495213, 24.422701885159558],
      [39.67309659619026, 24.42225660872701],
      [39.67303881345127, 24.42224363564472],
      [39.67273954348704, 24.422384985970407],
      [39.67256892524349, 24.4224959893942],
      [39.67298602556155, 24.42303824027277],
    ],
  ],
  [
    [
      [39.67068811467096, 24.426130194845886],
      [39.67096943270555, 24.4259469637805],
      [39.670797897132786, 24.4257261900974],
      [39.67051657931883, 24.425909419940833],
      [39.67068811467096, 24.426130194845886],
    ],
  ],
  [
    [
      [39.670859649633954, 24.426350968638438],
      [39.67114096789394, 24.42616773725422],
      [39.67096943270555, 24.4259469637805],
      [39.67068811467096, 24.426130194845886],
      [39.670859649633954, 24.426350968638438],
    ],
  ],
  [
    [
      [39.671312504675505, 24.4263885114129],
      [39.67114096789394, 24.42616773725422],
      [39.670859649633954, 24.426350968638438],
      [39.67103118618534, 24.426571742212833],
      [39.671312504675505, 24.4263885114129],
    ],
  ],
  [
    [
      [39.670173511416465, 24.425467871291357],
      [39.670210692180916, 24.42544365427055],
      [39.6701598196264, 24.425424640033],
      [39.67013942037005, 24.42542399341028],
      [39.670173511416465, 24.425467871291357],
    ],
  ],
  [
    [
      [39.670535057426974, 24.425564885084018],
      [39.670210692180916, 24.42544365427055],
      [39.670173511416465, 24.425467871291357],
      [39.67034504555985, 24.425688645720786],
      [39.670535057426974, 24.425564885084018],
    ],
  ],
  [
    [
      [39.67051657931883, 24.425909419940833],
      [39.670797897132786, 24.4257261900974],
      [39.670728841507604, 24.425637311377397],
      [39.670535057426974, 24.425564885084018],
      [39.67034504555985, 24.425688645720786],
      [39.67051657931883, 24.425909419940833],
    ],
  ],
  [
    [
      [39.670336829771365, 24.426376323674386],
      [39.670534501710435, 24.426244087474267],
      [39.67041441526003, 24.426089530995146],
      [39.67035968589891, 24.426081406788704],
      [39.67019134871617, 24.426194018625786],
      [39.670336829771365, 24.426376323674386],
    ],
  ],
  [
    [
      [39.670336829771365, 24.426376323674386],
      [39.67019134871617, 24.426194018625786],
      [39.67003205719306, 24.426300578944588],
      [39.67017753913103, 24.426482883238585],
      [39.670336829771365, 24.426376323674386],
    ],
  ],
  [
    [
      [39.670018247239426, 24.426589443546888],
      [39.67017753913103, 24.426482883238585],
      [39.67003205719306, 24.426300578944588],
      [39.66987276539553, 24.42640713819685],
      [39.670018247239426, 24.426589443546888],
    ],
  ],
  [
    [
      [39.670018247239426, 24.426589443546888],
      [39.66987276539553, 24.42640713819685],
      [39.669776684177776, 24.426471413502203],
      [39.66981163430063, 24.42649432041664],
      [39.669969295915024, 24.426622189484032],
      [39.670018247239426, 24.426589443546888],
    ],
  ],
  [
    [
      [39.670163728518276, 24.42677174874802],
      [39.670018247239426, 24.426589443546888],
      [39.669969295915024, 24.426622189484032],
      [39.67013309100607, 24.426755032791718],
      [39.670147791146945, 24.42678241042074],
      [39.670163728518276, 24.42677174874802],
    ],
  ],
  [
    [
      [39.670163728518276, 24.42677174874802],
      [39.67032302050871, 24.426665188286826],
      [39.67017753913103, 24.426482883238585],
      [39.670018247239426, 24.426589443546888],
      [39.670163728518276, 24.42677174874802],
    ],
  ],
  [
    [
      [39.67032302050871, 24.426665188286826],
      [39.67048231223426, 24.426558628565324],
      [39.670336829771365, 24.426376323674386],
      [39.67017753913103, 24.426482883238585],
      [39.67032302050871, 24.426665188286826],
    ],
  ],
  [
    [
      [39.67064560127485, 24.426449393030676],
      [39.67065458846064, 24.42639864475175],
      [39.670534501710435, 24.426244087474267],
      [39.670336829771365, 24.426376323674386],
      [39.67048231223426, 24.426558628565324],
      [39.67064560127485, 24.426449393030676],
    ],
  ],
  [
    [
      [39.669928242997834, 24.42621343515543],
      [39.66959984623604, 24.425786491719354],
      [39.66937420649367, 24.425937435189542],
      [39.669377927887275, 24.42595625546678],
      [39.6695056583841, 24.426238234247375],
      [39.669650426729895, 24.426388662374073],
      [39.66965844636925, 24.426393918366585],
      [39.669928242997834, 24.42621343515543],
    ],
  ],
  [
    [
      [39.66970696655688, 24.425831646900573],
      [39.67004479816326, 24.425613811167516],
      [39.669904760473216, 24.425433573367354],
      [39.66984984671766, 24.425425214970915],
      [39.669547386747865, 24.425624178957577],
      [39.66970696655688, 24.425831646900573],
    ],
  ],
  [
    [
      [39.67027963012856, 24.425978370244483],
      [39.67028861742806, 24.42592762107862],
      [39.670079105735326, 24.42565796717919],
      [39.66974104403781, 24.425875951218362],
      [39.66997603824355, 24.42618146201755],
      [39.67027963012856, 24.425978370244483],
    ],
  ],
  [
    [
      [39.671470082949135, 24.42659131977927],
      [39.671312504675505, 24.4263885114129],
      [39.67103118618534, 24.426571742212833],
      [39.67119130181861, 24.426777817101442],
      [39.67124603152688, 24.426785940998705],
      [39.671461097065574, 24.426642068094218],
      [39.671470082949135, 24.42659131977927],
    ],
  ],
  [
    [
      [39.669342789960126, 24.42558083754675],
      [39.66929038051964, 24.425513560724593],
      [39.669308186674705, 24.42560359974359],
      [39.669342789960126, 24.42558083754675],
    ],
  ],
  [
    [
      [39.66951902645931, 24.425464905179588],
      [39.66946040097427, 24.425389648700143],
      [39.66926368655001, 24.4253785811464],
      [39.66929038051964, 24.425513560724593],
      [39.669342789960126, 24.42558083754675],
      [39.66951902645931, 24.425464905179588],
    ],
  ],
  [
    [
      [39.66951902645931, 24.425464905179588],
      [39.669619798611016, 24.425398616058622],
      [39.66946040097427, 24.425389648700143],
      [39.66951902645931, 24.425464905179588],
    ],
  ],
  [
    [
      [39.67103199864849, 24.426884386642975],
      [39.670911910971, 24.426729829694743],
      [39.6707141836473, 24.426862102756786],
      [39.67085966721838, 24.427044407249557],
      [39.67102301158486, 24.42693513493856],
      [39.67103199864849, 24.426884386642975],
    ],
  ],
  [
    [
      [39.67085966721838, 24.427044407249557],
      [39.6707141836473, 24.426862102756786],
      [39.670554891753056, 24.426968663625285],
      [39.6707003752253, 24.427150968270958],
      [39.67085966721838, 24.427044407249557],
    ],
  ],
  [
    [
      [39.6707141836473, 24.426862102756786],
      [39.670568701483965, 24.426679798106385],
      [39.67040940968856, 24.42678635882196],
      [39.670554891753056, 24.426968663625285],
      [39.6707141836473, 24.426862102756786],
    ],
  ],
  [
    [
      [39.67039560057078, 24.427075223422882],
      [39.670554891753056, 24.426968663625285],
      [39.67040940968856, 24.42678635882196],
      [39.670250117623496, 24.426892919374136],
      [39.67039560057078, 24.427075223422882],
    ],
  ],
  [
    [
      [39.6707003752253, 24.427150968270958],
      [39.670554891753056, 24.426968663625285],
      [39.67039560057078, 24.427075223422882],
      [39.67054108295779, 24.42725752822585],
      [39.6707003752253, 24.427150968270958],
    ],
  ],
  [
    [
      [39.67039560057078, 24.427075223422882],
      [39.670250117623496, 24.426892919374136],
      [39.67021848761083, 24.426914078184257],
      [39.67032895033578, 24.427119809442853],
      [39.67039560057078, 24.427075223422882],
    ],
  ],
  [
    [
      [39.6707141836473, 24.426862102756786],
      [39.670911910971, 24.426729829694743],
      [39.670791823593326, 24.426575273544863],
      [39.67073709400116, 24.426567149480494],
      [39.670568701483965, 24.426679798106385],
      [39.6707141836473, 24.426862102756786],
    ],
  ],
  [
    [
      [39.67054108295779, 24.42725752822585],
      [39.67039560057078, 24.427075223422882],
      [39.67032895033578, 24.427119809442853],
      [39.67038751120378, 24.427228874774062],
      [39.6704881896206, 24.42728594861161],
      [39.67049613799646, 24.427287595937084],
      [39.67054108295779, 24.42725752822585],
    ],
  ],
  [
    [
      [39.67125911955421, 24.427392368418285],
      [39.67111710379367, 24.427207744148635],
      [39.670954344016025, 24.42731662562092],
      [39.67101735379326, 24.427395582051936],
      [39.67119828158159, 24.427433066316],
      [39.67125911955421, 24.427392368418285],
    ],
  ],
  [
    [
      [39.67101735379326, 24.427395582051936],
      [39.670954344016025, 24.42731662562092],
      [39.67087912557717, 24.427366944151885],
      [39.67101735379326, 24.427395582051936],
    ],
  ],
  [
    [
      [39.67196403728097, 24.427227048952446],
      [39.67183538192861, 24.427061467386388],
      [39.6715703679522, 24.42723235316222],
      [39.67169816296575, 24.427398489685544],
      [39.67196403728097, 24.427227048952446],
    ],
  ],
  [
    [
      [39.672350006351664, 24.427723792021578],
      [39.672221349983296, 24.427558210816308],
      [39.67211945977304, 24.427623912359593],
      [39.672162178174396, 24.4276327621054],
      [39.672223356700684, 24.4278054582155],
      [39.672350006351664, 24.427723792021578],
    ],
  ],
  [
    [
      [39.672221349983296, 24.427558210816308],
      [39.67209269395839, 24.427392630393864],
      [39.67182774158754, 24.427563475704332],
      [39.67211945977304, 24.427623912359593],
      [39.672221349983296, 24.427558210816308],
    ],
  ],
  [
    [
      [39.67182774158754, 24.427563475704332],
      [39.67209269395839, 24.427392630393864],
      [39.67196403728097, 24.427227048952446],
      [39.67169816296575, 24.427398489685544],
      [39.67182456676719, 24.42756281786608],
      [39.67182774158754, 24.427563475704332],
    ],
  ],
  [
    [
      [39.67182456676719, 24.42756281786608],
      [39.67169816296575, 24.427398489685544],
      [39.67153602367105, 24.427503039383257],
      [39.67182456676719, 24.42756281786608],
    ],
  ],
  [
    [
      [39.67169816296575, 24.427398489685544],
      [39.6715703679522, 24.42723235316222],
      [39.67132842573588, 24.427388360803082],
      [39.671394006185466, 24.427473615885596],
      [39.67153602367105, 24.427503039383257],
      [39.67169816296575, 24.427398489685544],
    ],
  ],
  [
    [
      [39.67132842573588, 24.427388360803082],
      [39.6715703679522, 24.42723235316222],
      [39.67140387230734, 24.427015904682268],
      [39.67116489909824, 24.427175770637795],
      [39.67132842573588, 24.427388360803082],
    ],
  ],
  [
    [
      [39.6715703679522, 24.42723235316222],
      [39.67183538192861, 24.427061467386388],
      [39.6716873777457, 24.426870983591847],
      [39.67163264797167, 24.4268628589526],
      [39.67140387230734, 24.427015904682268],
      [39.6715703679522, 24.42723235316222],
    ],
  ],
  [
    [
      [39.67247866305869, 24.427889373106577],
      [39.672350006351664, 24.427723792021578],
      [39.672223356700684, 24.4278054582155],
      [39.672295032106646, 24.428007782025638],
      [39.67247866305869, 24.427889373106577],
    ],
  ],
  [
    [
      [39.67295554878514, 24.427886851087234],
      [39.672924361394365, 24.427817736350008],
      [39.67293825856171, 24.427677074203924],
      [39.67276411978298, 24.427789363357867],
      [39.67287848192412, 24.427936545722304],
      [39.67295554878514, 24.427886851087234],
    ],
  ],
  [
    [
      [39.67303277128046, 24.42805798260419],
      [39.67295554878514, 24.427886851087234],
      [39.67287848192412, 24.427936545722304],
      [39.67299284531924, 24.428083727987318],
      [39.67303277128046, 24.42805798260419],
    ],
  ],
  [
    [
      [39.673064289186556, 24.428127830094894],
      [39.67303277128046, 24.42805798260419],
      [39.67299284531924, 24.428083727987318],
      [39.67304971824066, 24.42815692352946],
      [39.673064289186556, 24.428127830094894],
    ],
  ],
  [
    [
      [39.67296157052935, 24.427441115435677],
      [39.672997534355524, 24.427077087958327],
      [39.67298622879802, 24.42706253722504],
      [39.67277452162651, 24.427197953010488],
      [39.67296157052935, 24.427441115435677],
    ],
  ],
  [
    [
      [39.67264975790467, 24.42764217999529],
      [39.67296157052935, 24.427441115435677],
      [39.67277452162651, 24.427197953010488],
      [39.67249295218697, 24.427378055540533],
      [39.67248348001535, 24.427428180192205],
      [39.67264975790467, 24.42764217999529],
    ],
  ],
  [
    [
      [39.67293825856171, 24.427677074203924],
      [39.67296157052935, 24.427441115435677],
      [39.67264975790467, 24.42764217999529],
      [39.67276411978298, 24.427789363357867],
      [39.67293825856171, 24.427677074203924],
    ],
  ],
  [
    [
      [39.67247866305869, 24.427889373106577],
      [39.672295032106646, 24.428007782025638],
      [39.672312800045525, 24.428057939167612],
      [39.672588471586195, 24.428136069999713],
      [39.672610486406086, 24.42812134222975],
      [39.672619472903925, 24.4280705938597],
      [39.67247866305869, 24.427889373106577],
    ],
  ],
  [
    [
      [39.67220653794222, 24.424424591257328],
      [39.67203924548118, 24.42420710286524],
      [39.67200888413959, 24.424246174651838],
      [39.67196804417674, 24.424367716889353],
      [39.67196066927852, 24.424396651837835],
      [39.67205655315404, 24.424521306059507],
      [39.67220653794222, 24.424424591257328],
    ],
  ],
  [
    [
      [39.67190378515639, 24.42461981586617],
      [39.67205655315404, 24.424521306059507],
      [39.67196066927852, 24.424396651837835],
      [39.67190378515639, 24.42461981586617],
    ],
  ],
];
